import React from 'react';
import { formatPaymentStatusLabel } from '../../utils/bookingPayment';
import './BookingStripePayment.css';

const BookingInvoicePayment = ({
  amount,
  paymentStatus,
  hasInvoice,
  onDownloadInvoice,
  downloading = false
}) => {
  const paymentRowStatus = String(paymentStatus || 'not_started').toLowerCase();
  const isPaid = paymentRowStatus === 'paid' || paymentRowStatus === 'completed';

  return (
    <div className="booking-stripe-payment booking-invoice-payment" id="booking-invoice-payment">
      <div className="booking-stripe-payment__header">
        <h3>Pay using your invoice</h3>
        <span
          className={`booking-stripe-payment__pill booking-stripe-payment__pill--${paymentRowStatus}`}
        >
          {formatPaymentStatusLabel(paymentRowStatus)}
        </span>
      </div>

      <p className="booking-stripe-payment__hint">
        Pay the venue directly using the payment details on the uploaded invoice. Download the
        invoice from this page when it is available.
      </p>

      {amount != null && !isPaid ? (
        <p className="booking-stripe-payment__meta">
          Amount due: <strong>£{Number(amount).toFixed(2)}</strong>
        </p>
      ) : null}

      {isPaid ? (
        <p className="booking-stripe-payment__success">This booking is paid.</p>
      ) : hasInvoice ? (
        <button
          type="button"
          className="booking-stripe-payment__cta"
          onClick={onDownloadInvoice}
          disabled={downloading}
        >
          {downloading ? 'Preparing invoice…' : 'Download invoice'}
        </button>
      ) : (
        <p className="booking-stripe-payment__meta">
          Your invoice will appear here once the venue uploads it. You will receive an email when it
          is ready.
        </p>
      )}
    </div>
  );
};

export default BookingInvoicePayment;
